import React, { useState } from 'react'
import Styles from './Styles.module.css'
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown';
import openImg from '../../../../Assets/images/store_open.png'
import closeImg from '../../../../Assets/images/store_close.png'
import storeBusinessOffImg from '../../../../Assets/images/store_business_off.png'
import CustomeCheckBox from '../../../../Components/CheckBox/checkBox';


function RightCard({ sx, tabs, setTab }) {
  const [locationState, setLocationState] = useState([
    {
      label:"Open",
      name:"open",
      ischecked:false,
      value:"Open",
      Icon:openImg,
    },
    {
      label:"Close",
      name:"close",
      ischecked:false,
      value:"Close",
      Icon:closeImg,
    },
    {
      label:"Store Business Off",
      name:"storeBusinessOff",
      ischecked:false,
      value:"Store Business Off",
      Icon:storeBusinessOffImg,
    }
  ]);

 const handleLocation = (e,i) => {
     const {name,value}= e.target
  //  console.log("name",name);
  //  console.log("value",value);
  const duplicatelocationState=[...locationState]
  duplicatelocationState[i].ischecked=!duplicatelocationState[i].ischecked
  setLocationState(duplicatelocationState)
  }
  return (
    <div style={sx ? sx : {}} className={[`${Styles.navContainer}`]}>
      <div className={[`${Styles.nav}`]}>
        {/* {tabs.map((t,i)=>(<button key={i} onClick={()=>handleClick(t,i)} className={t.isActive?[`${Styles.active} ${Styles.navItem}`]:[`${Styles.navItem}`]}>{t.tab}</button>))}        */}
        <div className="wrapper">
          <p className={Styles.filterLabel}>Country: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[{ name: "India", code: "India" }, { name: "Argentina", code: "Argentina" },]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        <div className="wrapper">
          <p className={Styles.filterLabel}>City: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[{ name: "Bilaspur", code: "Bilaspur" }, { name: "Korba", code: "Korba" },]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        <div className="wrapper">
          <p className={Styles.filterLabel}>Order / Delivery Man: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[{ name: "Order", code: "Order" }, { name: "Delivery Man", code: "Delivery Man" },]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        <div className="wrapper">
          <p className={Styles.filterLabel}>Order No / Delivery Man Email: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        
        {/* <div className="wrapper">
          <p className={Styles.filterLabel}>State: </p>          
          {locationState.map((loc,i)=>(
            <div key={i} className={Styles.checkBoxWrapper}>
            <div className={Styles.checkBox}>             
               <CustomeCheckBox id={loc.name} name={loc.name} value={loc.value} checked={loc.ischecked} loc={loc} handleLocation={(e)=>handleLocation(e,i)} />
            </div>
            <img src={loc.Icon} alt="storeBusinessOff"/>            
          </div>
        ))}         
        </div> */}

     

      </div>

    </div>
  )
}

export default RightCard